/* Desi Soota — Wishlist v1 (guest / localStorage)
   Phase 2 (customer metafield sync) plugs into DSWishlist.set() */
(function () {
  'use strict';

  var STORAGE_KEY = 'ds_wishlist_v1';
  var MAX_ITEMS = 100;
  var MAX_SHARE = 25;
  var cache = {};

  /* ---------- storage ---------- */
  function read() {
    try {
      var raw = localStorage.getItem(STORAGE_KEY);
      var arr = raw ? JSON.parse(raw) : [];
      return Array.isArray(arr) ? arr.filter(function (h) {
        return typeof h === 'string' && h.length;
      }) : [];
    } catch (e) { return []; }
  }

  function write(list) {
    list = list.slice(0, MAX_ITEMS);
    try { localStorage.setItem(STORAGE_KEY, JSON.stringify(list)); } catch (e) {}
    document.dispatchEvent(new CustomEvent('wishlist:updated', { detail: { items: list } }));
    return list;
  }

  function has(handle) { return read().indexOf(handle) !== -1; }

  function add(handle) {
    var list = read();
    if (list.indexOf(handle) === -1) list.unshift(handle);
    return write(list);
  }

  function remove(handle) {
    return write(read().filter(function (h) { return h !== handle; }));
  }

  function toggle(handle) {
    var added = !has(handle);
    added ? add(handle) : remove(handle);
    return added;
  }

  /* ---------- product data ---------- */
  function getProduct(handle) {
    if (cache[handle]) return Promise.resolve(cache[handle]);
    return fetch('/products/' + handle + '.js', { credentials: 'same-origin' })
      .then(function (r) { return r.ok ? r.json() : Promise.reject(handle); })
      .then(function (p) { cache[handle] = p; return p; });
  }

  function money(paise) {
    try {
      return new Intl.NumberFormat('en-IN', {
        style: 'currency', currency: 'INR', maximumFractionDigits: 0
      }).format(paise / 100);
    } catch (e) { return '₹' + Math.round(paise / 100); }
  }

  function img(url, w) {
    if (!url) return '';
    return url.replace(/(\.[a-zA-Z]+)(\?|$)/, '_' + w + 'x$1$2');
  }

  /* ---------- analytics ---------- */
  function trackAdd(handle) {
    getProduct(handle).then(function (p) {
      if (window.fbq) {
        fbq('track', 'AddToWishlist', {
          content_ids: [String(p.id)],
          content_type: 'product',
          content_name: p.title,
          value: p.price / 100,
          currency: 'INR'
        });
      }
      if (window.dataLayer) {
        dataLayer.push({ event: 'add_to_wishlist', item_id: String(p.id), item_name: p.title });
      }
    }).catch(function () {});
  }

  /* ---------- UI: buttons ---------- */
  function syncButtons() {
    var list = read();
    document.querySelectorAll('[data-wishlist-toggle]').forEach(function (btn) {
      var on = list.indexOf(btn.getAttribute('data-wishlist-toggle')) !== -1;
      btn.classList.toggle('is-active', on);
      btn.setAttribute('aria-pressed', on ? 'true' : 'false');
     btn.setAttribute('aria-label', on ? 'Remove from wishlist' : 'Save to wishlist');
      var lbl = btn.querySelector('.ds-wl-heart__label');
      if (lbl) lbl.textContent = on ? 'Wishlisted' : 'Add to wishlist';
    });
    var n = list.length;
    document.querySelectorAll('[data-wishlist-count]').forEach(function (el) {
      el.textContent = n;
      el.classList.toggle('is-empty', n === 0);
    });
  }

  /* ---------- UI: toast ---------- */
  var toastTimer;
  function toast(msg) {
    var el = document.querySelector('.ds-wl-toast');
    if (!el) {
      el = document.createElement('div');
      el.className = 'ds-wl-toast';
      el.setAttribute('role', 'status');
      document.body.appendChild(el);
    }
    el.textContent = msg;
    el.classList.add('is-visible');
    clearTimeout(toastTimer);
    toastTimer = setTimeout(function () { el.classList.remove('is-visible'); }, 2600);
  }

  /* ---------- sharing ---------- */
  function shareUrl(list) {
    return location.origin + '/pages/wishlist?w=' +
      encodeURIComponent((list || read()).slice(0, MAX_SHARE).join(','));
  }

  function waShare(text, url) {
    window.open('https://wa.me/?text=' + encodeURIComponent(text + '\n' + url),
      '_blank', 'noopener');
  }

  function nativeShare(title, text, url) {
    if (navigator.share) {
      navigator.share({ title: title, text: text, url: url }).catch(function () {});
      return true;
    }
    if (navigator.clipboard) {
      navigator.clipboard.writeText(url).then(function () { toast('Link copied'); });
      return true;
    }
    return false;
  }

  /* ---------- UI: wishlist page ---------- */
  function card(p, opts) {
    var v = p.variants && p.variants[0];
    var compare = v && v.compare_at_price > v.price
      ? '<s class="ds-wl-card__was">' + money(v.compare_at_price) + '</s>' : '';
    var sold = p.available ? '' : '<span class="ds-wl-card__sold">Sold out</span>';
    var action = opts.shared
      ? ''
      : '<button type="button" class="ds-wl-card__remove" data-wishlist-remove="' + p.handle +
        '" aria-label="Remove ' + p.title + ' from wishlist">Remove</button>';

    return '' +
      '<li class="ds-wl-card">' +
        '<a class="ds-wl-card__media" href="/products/' + p.handle + '" aria-hidden="true" tabindex="-1">' +
          '<img src="' + img(p.featured_image, 400) + '" alt="" loading="lazy" width="400" height="600">' +
          sold +
        '</a>' +
        '<div class="ds-wl-card__body">' +
          '<a class="ds-wl-card__title" href="/products/' + p.handle + '">' + p.title + '</a>' +
          '<p class="ds-wl-card__price">' + money(p.price) + ' ' + compare + '</p>' +
          '<div class="ds-wl-card__actions">' +
            '<a class="ds-wl-btn ds-wl-btn--primary" href="/products/' + p.handle + '">View</a>' +
            '<button type="button" class="ds-wl-btn ds-wl-btn--ghost" data-wishlist-share-product="' +
              p.handle + '">Share</button>' +
          '</div>' +
          action +
        '</div>' +
      '</li>';
  }

  function renderPage() {
    var root = document.querySelector('[data-wishlist-page]');
    if (!root) return;

    var params = new URLSearchParams(location.search);
    var sharedRaw = params.get('w');
    var shared = !!sharedRaw;
    var handles = shared
      ? sharedRaw.split(',').map(function (h) { return h.trim(); }).filter(Boolean).slice(0, MAX_SHARE)
      : read();

    var grid = root.querySelector('[data-wishlist-grid]');
    var empty = root.querySelector('[data-wishlist-empty]');
    var tools = root.querySelector('[data-wishlist-tools]');
    var banner = root.querySelector('[data-wishlist-shared-banner]');

    if (banner) banner.hidden = !shared;
    if (tools) tools.hidden = shared || !handles.length;

    if (!handles.length) {
      grid.innerHTML = '';
      empty.hidden = false;
      return;
    }
    empty.hidden = true;
    grid.innerHTML = '<li class="ds-wl-loading">Loading your saved items…</li>';

    Promise.all(handles.map(function (h) {
      return getProduct(h).catch(function () { return null; });
    })).then(function (products) {
      var live = products.filter(Boolean);
      var deadCount = products.length - live.length;

      // prune handles that no longer resolve (renamed / deleted products)
      if (!shared && deadCount) {
        write(live.map(function (p) { return p.handle; }));
      }
      if (!live.length) {
        grid.innerHTML = '';
        empty.hidden = false;
        return;
      }
      grid.innerHTML = live.map(function (p) {
        return card(p, { shared: shared });
      }).join('');
      syncButtons();
    });
  }

  /* ---------- events ---------- */
  document.addEventListener('click', function (e) {
    var t;

    if ((t = e.target.closest('[data-wishlist-toggle]'))) {
      e.preventDefault();
      e.stopPropagation();
      var handle = t.getAttribute('data-wishlist-toggle');
      var added = toggle(handle);
      syncButtons();
      if (added) { trackAdd(handle); toast('Saved to wishlist'); }
      else { toast('Removed from wishlist'); if (document.querySelector('[data-wishlist-page]')) renderPage(); }
      return;
    }

    if ((t = e.target.closest('[data-wishlist-remove]'))) {
      e.preventDefault();
      remove(t.getAttribute('data-wishlist-remove'));
      renderPage();
      syncButtons();
      return;
    }

    if ((t = e.target.closest('[data-wishlist-share-product]'))) {
      e.preventDefault();
      var h = t.getAttribute('data-wishlist-share-product');
      var url = location.origin + '/products/' + h;
      getProduct(h).then(function (p) {
        if (!nativeShare(p.title, p.title, url)) waShare('Look at this — ' + p.title, url);
      });
      return;
    }

    if (e.target.closest('[data-wishlist-share-whatsapp]')) {
      e.preventDefault();
      waShare('Here are the pieces I picked out from Desi Soota 🧡', shareUrl());
      return;
    }

    if (e.target.closest('[data-wishlist-share-copy]')) {
      e.preventDefault();
      var u = shareUrl();
      if (navigator.clipboard) navigator.clipboard.writeText(u).then(function () { toast('Link copied'); });
      else prompt('Copy your wishlist link:', u);
      return;
    }

    if ((t = e.target.closest('[data-wishlist-save-shared]'))) {
      e.preventDefault();
      var p2 = new URLSearchParams(location.search).get('w') || '';
      var incoming = p2.split(',').map(function (x) { return x.trim(); }).filter(Boolean);
      var merged = read();
      incoming.forEach(function (h) { if (merged.indexOf(h) === -1) merged.push(h); });
      write(merged);
      toast('Added to your wishlist');
      location.href = '/pages/wishlist';
    }
  });

  document.addEventListener('wishlist:updated', syncButtons);

  function init() { syncButtons(); renderPage(); }
  document.readyState === 'loading'
    ? document.addEventListener('DOMContentLoaded', init)
    : init();

  // Impulse fires this after AJAX-loaded grids / quick view
  document.addEventListener('shopify:section:load', init);

  window.DSWishlist = {
    get: read, set: write, add: add, remove: remove,
    has: has, toggle: toggle, refresh: init, shareUrl: shareUrl
  };
})();